import useTranslation from "@hooks/use_translation";
import DreamJobIcon from "@/sprout/icons/dream_job";
import { dreamJobStatusText } from "@/utils/date_utils";
import "@/stylesheets/dream_job_icon.scss";
import { Body } from "@sprout/typography";
import DreamJobPickerModal from "@components/applications/dream_job_picker_modal";
import useTask from "@/hooks/use_task";
import { useTaskDismiss } from "@components/dashboard/tasks/taskActions";
import { TertiaryButton } from "@sprout/buttons";

type Props = {
  redirectTo?: string;
  className?: string;
};

const DreamJobCallout = ({ redirectTo = "/applications", className }: Props) => {
  const { t } = useTranslation("applications");
  const { data: dreamJobTask } = useTask("ChooseDreamJob");
  const handleDismiss = useTaskDismiss(dreamJobTask?.id, {
    redirectTo,
    taskableType: "ChooseDreamJob",
  });

  if (!dreamJobTask || dreamJobTask.dismissed) {
    return null;
  }

  return (
    <div
      className={`w-full bg-marigold-25 px-6 py-4 border border-marigold-e50 rounded-lg ${className ?? ""}`}
    >
      <div className="flex flex-col justify-between gap-3 items-start h-full">
        <div className="flex gap-1 items-center">
          <div className="bg-marigold-e50 dream-job-icon">
            <DreamJobIcon size="sm" />
          </div>
          <p className="text-xs ml-1">
            {dreamJobStatusText((key, opts) => t(`dream_job_callout.${key}`, opts))}
          </p>
        </div>
        <Body medium>{t("dream_job_callout.title")}</Body>
        <p className="text-sm">{t("dream_job_callout.description")}</p>
        <div className="flex items-center gap-4">
          <DreamJobPickerModal />
          <TertiaryButton secondary onClick={handleDismiss}>
            {t("dismiss")}
          </TertiaryButton>
        </div>
      </div>
    </div>
  );
};

export default DreamJobCallout;
